import React from 'react';
import { Route, Routes } from 'react-router-dom';
import OrderTracking from '../../containers/Public/OrderTracking';
import NotFound from '../../containers/NotFound';

export const PUBLIC_ROUTE_PREFIX = 'track';

const PublicRouter: React.FC = () => (
	<Routes>
		<Route path="/track/:token" element={<OrderTracking />} />
		<Route path="/*" element={<NotFound />} />
	</Routes>
);

export default PublicRouter;
